if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cartNotification = document.querySelector('cart-notification');
      this._selectors = {
        addToCart: "[js-add-to-cart]",
        error: '[js-error-message]',
        form: "[js-product-form]",
        loader: "loading-spinner",
      };
    }

    connectedCallback() {
      this.buttons = this.querySelectorAll(this._selectors.addToCart);
      this.addEventListener("variant:change", this._handleVariantChange);
      this._initProductForm();
    }
  
    _initProductForm() {
      this.form = this.querySelector(this._selectors.form);
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-drawer');
      this.cartDrawer = document.querySelector('#CartDrawer')
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
  
      this.handleErrorMessage();
  
      this._disableButtons();
  
      const config = {
        method: 'POST',
        headers: { Accept: `application/javascript`, 'X-Requested-With': 'XMLHttpRequest' },
      }
  
      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append(
          'sections',
          this.cart.getSectionsToRender().map((section) => section.id)
        );
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;
  
      fetch(`${window.routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            theme.utils.subscriptions.publish(window.PUB_SUB_EVENTS.cartError, {
              source: 'product-form',
              productVariantId: formData.get('id'),
              errors: response.errors || response.description,
              message: response.message,
            });
            this.handleErrorMessage(response.description);
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          if (!this.error)
            theme.utils.subscriptions.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: formData.get('id') });
            this.error = false;
            this.cart.renderContents(response);
            this.cartDrawer.open();
          })
          .catch((e) => {
            /* Handle error selector */
            this.handleErrorMessage(e.description)
            console.error(e);
          })
        .finally(() => {
          this._enableButtons();
        });
    }
  
    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.querySelector(this._selectors.error)
  
      if (errorMessage) {
        this.errorMessageWrapper.innerHTML = errorMessage;
        this.errorMessageWrapper.classList.remove('hidden');
      }else{
        this.errorMessageWrapper.classList.add('hidden');
      }
    }
  
    _handleVariantChange = (evt) => {
      const { variant, priceChange } = evt.detail;
  
      this._updateAddToCartState(variant);
  
      if (variant) {
        if (priceChange) this._updatePrice(variant);
      }
    };
  
    _updateAddToCartState(variant) {
      const buttons = this.querySelectorAll(this._selectors.addToCart);
      if (variant) {
        if (variant.available) {
          buttons.forEach((btn) => {
            btn.textContent = "Add To Cart";
            btn.removeAttribute("disabled");
          });
        } else {
          buttons.forEach((btn) => {
            btn.textContent = "Sold out";
            btn.setAttribute("disabled", true);
          });
        }
      } else {
        buttons.forEach((btn) => {
          btn.textContent = "Unavailable";
          btn.setAttribute("disabled", true);
        });
      }
    }


    _updatePrice(variant) {
      //update price
    }
  
    _disableButtons() {
      this.buttons.forEach((button) => {
        button.setAttribute("disabled", true);
        button.classList.add('loading');
      });
    }
  
    _enableButtons() {
      this.buttons.forEach((button) => {
        button.removeAttribute("disabled");
        if (button.classList.contains('loading')) {
          button.classList.remove('loading');
        }            
      });
    }
  });
}
